export default __webpack_public_path__ + "static/media/loader.0257b513.gif";